import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsLandingTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['landing']> = {
  zh: {
    navYourOms: '你的 OMS',
    heroTitleLine1: '海外仓一件代发',
    heroTitleLine2: '目前最快的跨境履约方式',
    heroDescription: '出单后2-5天送达，时效媲美本土卖家。',
    actionLearnMore: '了解详情',
    actionShippingCalculator: '运费试算',
  },
  en: {
    navYourOms: 'Your OMS',
    heroTitleLine1: 'Overseas Warehouse Dropshipping',
    heroTitleLine2: 'The fastest cross-border fulfillment model',
    heroDescription: 'Deliver in 2-5 days after order placement, with local-seller-level transit speed.',
    actionLearnMore: 'Learn more',
    actionShippingCalculator: 'Shipping calculator',
  },
};
